import styled from 'styled-components'

interface LoaderContainerProps {
  fullPage?: boolean
}

export const Container = styled.div<LoaderContainerProps>`
  ${(props) =>
    props.fullPage
      ? `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  `
      : `
  position: relative;
  height: 100%;
  `}
`
